import { FirebaseAuthentication } from "@capacitor-firebase/authentication"
import { Capacitor } from "@capacitor/core"
import { Haptics, ImpactStyle } from "@capacitor/haptics"
import { Preferences } from "@capacitor/preferences"

export const lightImpact = () => {
  if (Capacitor.isNativePlatform()) {
    Haptics.impact({ style: ImpactStyle.Light })
  }
}

export const mediumImpact = () => {
  if (Capacitor.isNativePlatform()) {
    Haptics.impact({ style: ImpactStyle.Medium })
  }
}

const heavyImpact = () => {
  if (Capacitor.isNativePlatform()) {
    Haptics.impact({ style: ImpactStyle.Heavy })
  }
}

export const signOut = async () => {
  if (Capacitor.isNativePlatform()) {
    Haptics.impact({ style: ImpactStyle.Medium })
  }
  
  // Dispatch a custom event before clearing preferences
  // This allows components to react to the sign out before data is cleared
  window.dispatchEvent(new CustomEvent('user-signout'));
  
  // Clear all preferences
  await Preferences.clear();
  
  // Sign out from Firebase
  await FirebaseAuthentication.signOut();
  
  console.log('User signed out and preferences cleared');
  return true;
}